import { render, staticRenderFns } from "./FindPwd.vue?vue&type=template&id=73f022c4"
import script from "./FindPwd.vue?vue&type=script&lang=js"
export * from "./FindPwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports